// Single source of truth for the Omnyx logo files (live in /public).
export const LOGO_ICON_SRC = "/logo192.png"; // icon mark only
export const LOGO_FULL_SRC = "/Logo_Text.png"; // icon + "Omnyx" wordmark

// Ingroove brand assets (hosted externally / in /public).
export const INGROOVE_LOGO_SRC = "https://ingroove.co.za/logo.svg";
export const INGROOVE_BANNER_SRC = "/ingroove.png";
